import React, { useState } from "react";
import "./PrimeLocations.scss";

const locations = [
  {
    name: "Hyderabad",
    image: "https://i.pinimg.com/736x/6f/65/be/6f65be65df7d422493344a00b97ad6cb.jpg",
    description:
      "Hyderabad, the City of Pearls, blends rich heritage with modern innovation. Known for its IT hubs, iconic Charminar, and delectable biryani, it’s a thriving business and cultural center. The city’s excellent infrastructure and talent pool make it a preferred destination for technology, education, and real estate investments.",
  },
  {
    name: "Vijayawada",
    image: "https://s3.ap-southeast-1.amazonaws.com/images.deccanchronicle.com/dc-Cover-9p7sib989iv43l5ik363fav9b7-20210626233053.Medi.jpeg",
    description:
      "Vijayawada, the commercial capital of Andhra Pradesh, is known for its vibrant economy, connectivity, and educational institutions. Situated along the Krishna River, it’s a fast-growing urban center with thriving real estate, trade, and transport sectors. The city combines traditional charm with a modern lifestyle and strong infrastructure.",
  },
  {
    name: "Vizag",
    image: "https://assets.thehansindia.com/h-upload/feeds/2019/05/10/173219-vizag.jpg",
    description:
      "Vizag, the Jewel of the East Coast, is Andhra Pradesh’s coastal paradise. With serene beaches, growing industries, and a strategic port, it’s an emerging hub for tourism, trade, and technology. The city’s scenic beauty, clean environment, and rapid urban growth make it ideal for living and investment opportunities.",
  },
  {
    name: "Guntur",
    image: "https://media.assettype.com/tnm%2Fimport%2Fsites%2Fdefault%2Ffiles%2FGuntur_Jinnah_Tower_Tricolour_1200x800_IANS_02022022.jpg?w=1024&auto=format%2Ccompress&fit=max",
    description:
      " Guntur, famous for its rich agricultural base and spicy chilies, is a rapidly developing city in Andhra Pradesh. With strong trade networks, educational excellence, and expanding real estate, Guntur is transforming into a modern business hub while retaining its cultural essence and community-oriented lifestyle.",
  },
];

const PrimeLocations = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeLocation = locations[activeIndex];

  return (
    <div className="prime-locations-container">
      <h2 className="section-title">Prime Locations</h2>
      <div className="content-wrapper">
        <div className="location-list">
          {locations.map((loc, idx) => (
            <div
              key={idx}
              className={`location-item ${activeIndex === idx ? "active" : ""}`}
              onClick={() => setActiveIndex(idx)}
            >
              {loc.name}
            </div>
          ))}
        </div>
        <div className="location-details">
          <div className="image-wrapper">
            <img src={activeLocation.image} alt={activeLocation.name} />
          </div>
          <div className="text">
            <p>{activeLocation.description}</p>
            <p>{activeLocation.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimeLocations;
